import React from 'react';

const Alabama = () => (
  <svg
    width="52"
    height="84"
    viewBox="0 0 52 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7912 81.327C17.1083 81.2496 16.2494 83.4112 15.7425 81.841C14.3556 81.4749 16.1086 84.2561 14.7217 83.8899C13.025 83.5379 13.546 80.975 11.1382 81.327C11.4762 78.5952 10.8426 76.8491 9.08958 76.2083C8.03356 77.5391 8.00539 79.9048 8.06876 82.355C6.87193 82.355 5.68213 82.355 4.48531 82.355C3.40113 78.215 3.50673 73.6102 2.95056 69.0407C2.25359 63.3446 0.176768 58.24 0.901902 51.1216C2.20433 38.3565 1.25392 21.4091 1.92273 7.09498C2.77459 5.16577 -0.456844 4.76445 0.901902 4.02516C12.9405 3.60975 23.9513 2.15931 35.2014 0.955322C37.1375 9.03826 40.4604 17.9098 42.8822 26.556C43.7059 29.485 43.9664 32.583 44.9309 35.2585C45.4167 36.6104 46.2263 38.6663 46.9796 39.8633C47.4583 40.6237 48.6551 41.0813 49.0283 41.9122C49.507 42.9753 48.3806 44.989 50.0491 45.496C49.0775 47.1717 48.9297 48.2208 48.5143 50.6147C47.9934 53.6352 48.3383 55.1842 50.0491 57.7823C49.9435 59.3876 50.3941 61.5422 49.5352 62.3871C49.5985 64.5416 51.5205 64.8373 51.5838 66.9918C43.6285 67.4002 34.075 69.1604 25.479 70.0616C21.3605 70.4911 15.651 69.4068 14.2148 72.6175C14.5668 74.9973 16.5732 75.7225 17.7982 77.2222C17.0872 78.7783 18.0376 79.0599 17.7912 81.327Z"
      fill="#FC374D"
    />
  </svg>
);

export default Alabama;
